var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"loadingContainer"},[_c('div',{staticStyle:{"width":"100%"}},[_c('Datatable',_vm._b({attrs:{"HeaderSettings":false}},'Datatable',_vm.$data,false),[(_vm.pending)?_c('div',{attrs:{"slot":"table"},slot:"table"}):_vm._e()])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }